import type React from 'react';

export const LoadingSkeleton: React.FC = () => {
	return (
		<div
			data-testid="media-hits-loading"
			className="animation-duration-[500ms] bg-fill-disabled my-4 h-[150px] w-full animate-pulse rounded-md"
		/>
	);
};
